import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { Country, EditStateRow } from '../models/store.model';

export const GetCountries = createAction('[Store Management: Search]: Get Countries');

export const GetCountriesSuccess = createAction(
  '[Store Management: Search]: Get Countries Success',
  props<{ res: Country[] }>(),
);

export const GetCountriesFailed = createAction(
  '[Store Management: Search]: Get Countries Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenSidenav = createAction('[Store Management: Search]: Open Sidenav');

export const CloseSidenav = createAction('[Store Management: Search]: Close Sidenav');

export const EditStore = createAction(
  '[Store Management: Search]: Edit Store',
  props<{ store: EditStateRow }>(),
);

export const PanelStatusChanged = createAction('[Store Management: Search]: Panel Status Changed');

export const StoreNameChanged = createAction(
  '[Store Management: Search]: Store Name Changed',
  props<{ storeName: string }>(),
);

export const StoreCodeChanged = createAction(
  '[Store Management: Search]: Store Code Changed',
  props<{ storeCode: string }>(),
);

export const ShowInactiveErrorsChanged = createAction(
  '[Store Management: Search]: Show Inactive Errors Changed',
);

export const ClearStoreOptions = createAction('[Store Management: Search]: Clear Store Options');

export const StoreGridSuccess = createAction(
  '[Store Management]: Store Grid Success',
  props<{ res: QcResponseGrid }>(),
);

export const TableCountryCodeChanged = createAction(
  '[Store Management]: Table Country Code Changed',
  props<{ id: string; languageCode: string }>(),
);

export const DeactivateStoreModal = createAction('[Store Management]: Deactivate Store Modal');

export const DeactivateStore = createAction('[Store Management]: Deactivate Store');

export const DeactivateStoreSuccess = createAction(
  '[Store Management: Search]: Deactivate Store Success',
  props<{ res: any }>(),
);

export const DeactivateStoreFailed = createAction(
  '[Store Management: Search]: Deactivate Store Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ActivateStore = createAction(
  '[Store Management]: Activate Store',
  props<{ store: any }>(),
);

export const ActivateStoreSuccess = createAction(
  '[Store Management: Search]: Activate Store Success',
  props<{ res: any }>(),
);

export const ActivateStoreFailed = createAction(
  '[Store Management: Search]: Activate Store Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLocaleData = createAction('[Store Management: Search]: Get Locale Data');

export const GetLocaleDataSuccess = createAction(
  '[Store Management: Search]: Get Locale Data Success',
  props<{ res: any }>(),
);

export const GetLocaleDataFailed = createAction(
  '[Store Management: Search]: Get Locale Data Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GridStoreSearch = createAction('[Store Management: Search]: Grid Store Search');
